<app-loading [show]="loading"></app-loading>
<div class="space-y-4">
  <div class="flex flex-col sm:flex-row justify-between items-center gap-2">
    <h1 class="text-2xl font-bold text-gray-800">Logs Conexão MQTT</h1>

    <div class="flex items-center gap-2 w-full sm:w-auto">
      <app-data-picker [range]="rangeData" (rangeChange)="onRangeChanged($event)"></app-data-picker>
      <app-select
        [options]="typeOptions"
        [formControl]="type"
        placeholder="Tipo de log"
        class="min-w-40"
      ></app-select>
      <app-input
        type="text"
        [(ngModel)]="filterText"
        (input)="applyFilter()"
        placeholder="Filtrar logs..."
        class="bg-white rounded border border-gray-200"
      ></app-input>
    </div>
  </div>

  <div class="overflow-x-auto shadow rounded-2xl border border-gray-200 w-full">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer"
            (click)="toggleSort()"
          >
            Data/Hora
            <span>
              {{ sortDirection === 'asc' ? '↑' : '↓' }}
            </span>
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">
            Log Stream
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">
            Mensagem
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-100">
        @for (log of filteredConnections; track $index) {
        <tr class="hover:bg-gray-50 transition">
          <td class="px-4 py-2 text-sm text-gray-700 whitespace-nowrap">
            {{ formatDate(log.timestamp) }}
          </td>
          <td class="relative group max-w-[150px] whitespace-nowrap overflow-hidden text-ellipsis">
            {{ log.logStreamName }}
          </td>
          <td class="px-4 py-2 text-sm">
            <pre class="whitespace-pre-wrap break-words" [ngClass]="getMessageClass(log.message)"
              >{{ formatJson(log.message) }}
                </pre
            >
          </td>
        </tr>
        } @if (filteredConnections.length === 0) {
        <tr>
          <td colspan="3" class="text-center text-gray-500 py-4">Nenhum log encontrado</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
